module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"WidgetSettingsTypes":{"buttonAdd":"Добавить виджет","messageCompositeListIsEmpty":"Список виджетов пуст..."}},"en_us":{"WidgetSettingsTypes":{"buttonAdd":"Add widget","messageCompositeListIsEmpty":"The list of widgets is empty..."}}}')
  delete Component.options._Ctor
}
